'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../Language/index.js');
var Currency = require('../../transformers/Currency.js');
var useLanguage = require('../../hooks/useLanguage.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Fees = _ref => {
  let {
    fees,
    locale,
    labelFreeKey = null,
    includeCurrency
  } = _ref;
  const filteredFees = fees === null || fees === void 0 ? void 0 : fees.filter(e => e.amount.value !== 0);
  const defaultFreeLabel = useLanguage["default"]({
    langKey: 'returnsPudoListFeeLabelFree'
  }).value ?? '';
  if (!filteredFees || filteredFees.length === 0) return /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: labelFreeKey,
    defaultString: defaultFreeLabel
  });
  const [initialFee, ...extraFees] = filteredFees;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
    locale: locale,
    includeCurrency: includeCurrency,
    value: initialFee.amount.value,
    currency: initialFee.amount.currency || 'USD'
  }), extraFees.map(fee => {
    return /*#__PURE__*/React__default["default"].createElement("span", {
      key: `${fee.amount.value}${fee.type}`
    }, '+ ', /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
      locale: locale,
      includeCurrency: includeCurrency,
      value: fee.amount.value,
      currency: fee.amount.currency || 'USD'
    }), ' ', /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        textTransform: 'capitalize',
        whiteSpace: 'nowrap'
      }
    }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: `returnsPudoListFeeLabel${fee.type.replace('_', '').toLowerCase()}`,
      defaultString: fee.type.toLowerCase().replace('_', ' '),
      noWrap: true
    })));
  }));
};

exports["default"] = Fees;
